module.exports = __webpack_public_path__ + "img/ptzc-large-one.f8a42e47.png";